const getCreditCards = state => state.creditCards;

export default {
  getCreditCards,
};
